import * as _ from 'lodash';
import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { getNames } from 'i18n-iso-countries';

import { LanguageService } from 'services';
import { FcpDropdownItem } from 'fc-ui-components';

@Component({
    selector: 'fc-clara-address-form',
    templateUrl: './address-form.component.html',
    styleUrls: ['./address-form.component.less'],
    standalone: false
})
export class AddressFormComponent {
    @Input() addressForm: UntypedFormGroup;

    countries: Country[];
    topCountries: Country[];
    countryDropdownItems: FcpDropdownItem[];

    constructor(private languageService: LanguageService) {
        this.topCountries = [
            { code: 'DE', name: 'Germany' },
            { code: 'FR', name: 'France' },
            { code: 'NL', name: 'Netherlands' },
            { code: 'RU', name: 'Russia' },
            { code: 'BE', name: 'Belgium' },
            { code: 'CH', name: 'Switzerland' },
            { code: 'AT', name: 'Austria' },
            { code: 'GB', name: 'United Kingdom' }
        ];

        this.countries = this.mapCountries();
        this.countryDropdownItems = [
            ...this.topCountries.map((country) => ({ value: country.code, label: country.name })),
            ...this.countries.map((country) => ({ value: country.code, label: country.name }))
        ];
    }

    hasToShowError(name: string): boolean {
        return this.addressForm.get(name).invalid && this.addressForm.get(name).dirty;
    }

    mapCountries(): Country[] {
        return _.map(getNames(this.languageService.getCurrentLanguage() || 'en'), (name: string, code: string) => ({
            name,
            code
        }));
    }

    getSelectedCountry(item: FcpDropdownItem) {
        return item.value;
    }

    setSelectedCountry(item: FcpDropdownItem, items: FcpDropdownItem[]) {
        return Array.isArray(items) ? items.find((country) => country.value === item) : null;
    }
}

interface Country {
    code: string;
    name: string;
}
